import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-64bbac8d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex col align-center" }
const _hoisted_2 = { class: "flex align-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted bold" }, "Couleur selectionnée : ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Vue3ColorPicker = _resolveComponent("Vue3ColorPicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "color-indicator",
        style: _normalizeStyle(_ctx.colorIndicator)
      }, null, 4)
    ]),
    _createVNode(_component_Vue3ColorPicker, {
      showAlpha: false,
      modelValue: _ctx.pureColor,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pureColor) = $event)),
      mode: "solid",
      showColorList: false,
      showInputMenu: false,
      showInputSet: false,
      showPickerMode: false,
      showEyeDrop: true,
      type: "RGBA"
    }, null, 8, ["modelValue"])
  ]))
}